import { render, staticRenderFns } from "./wl-header.vue?vue&type=template&id=107a8627&"
import script from "./wl-header.vue?vue&type=script&lang=js&"
export * from "./wl-header.vue?vue&type=script&lang=js&"
import style0 from "./wl-header.vue?vue&type=style&index=0&id=107a8627&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_1526cca7f574ee28884ce00d85ec031a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports